export function DiamondLogo({ size = 32 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="LCC Logo">
      {/* Outer diamond */}
      <polygon points="16,1 31,16 16,31 1,16" fill="#1A2E44" />
      {/* Middle diamond */}
      <polygon points="16,6 27,16 16,26 5,16" fill="#C9A84C" />
      {/* Inner diamond */}
      <polygon points="16,11 22,16 16,21 10,16" fill="#1A2E44" />
      {/* Centre dot */}
      <circle cx="16" cy="16" r="2" fill="#C9A84C" />
    </svg>
  );
}
